import { CATEGORY_TYPE } from 'models/documents.model';

export const parseAdditionalDetails = (
  type: CATEGORY_TYPE,
  additionalDetails: Record<string, any>
) => {
  const parseToDataSetObject = (obj: Record<string, string>) =>
    Object.keys(obj).map((k) => ({
      label: k,
      value: obj[k],
    }));

  const {
    producer,
    cobaltProducer,
    lithiumProducer,
    details,
    sizeCalculation,
    chemicalComposition,
    particleSizeDistribution,
    physicalProperties,
  } = additionalDetails;

  if (type === CATEGORY_TYPE.CERTIFICATE) {
    additionalDetails.certificateName = additionalDetails.productName;
  }

  if (
    [
      CATEGORY_TYPE.BATTERY_TECH_REVIEW,
      CATEGORY_TYPE.BATTERY_PACKS_REPAIR,
      CATEGORY_TYPE.BATTERY_REPURPOSE,
      CATEGORY_TYPE.BATTERY_PACKS_RECYCLING,
      CATEGORY_TYPE.BATTERY_WASTE,
    ].includes(type)
  ) {
    additionalDetails.productId = `${details.batteryPackSerialNumber}${additionalDetails.assemblyNumber}`;
  }

  if (producer) {
    additionalDetails.producer = parseToDataSetObject(producer);
  }

  if (cobaltProducer) {
    additionalDetails.cobaltProducer = parseToDataSetObject(cobaltProducer);
  }

  if (lithiumProducer) {
    additionalDetails.lithiumProducer = parseToDataSetObject(lithiumProducer);
  }

  if (details) {
    additionalDetails.details = parseToDataSetObject(details);
  }

  if (sizeCalculation) {
    additionalDetails.sizeCalculation = parseToDataSetObject(sizeCalculation);
  }

  if (chemicalComposition) {
    additionalDetails.chemicalComposition = parseToDataSetObject(chemicalComposition);
  }

  if (particleSizeDistribution) {
    additionalDetails.particleSizeDistribution = parseToDataSetObject(particleSizeDistribution);
  }

  if (physicalProperties) {
    additionalDetails.physicalProperties = parseToDataSetObject(physicalProperties);
  }

  return additionalDetails;
};
